import "./App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import FindBatteryPage from "./pages/FindBatteryPage";
import ProductsPage from "./pages/ProductsPage";
import HupsPage from "./pages/HupsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";

const TOASTER_OPTIONS = {
  style: { background: "#ffffff", color: "#232620", border: "1px solid rgba(0,0,0,0.1)" },
};

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Alias route: /find-battery/request scrolls to the lead form section
    // so we can share a clean, self-explanatory URL with customers.
    const wantsLeadForm = pathname.endsWith("/find-battery/request") || hash === "#lead-form";
    if (wantsLeadForm) {
      const raf = requestAnimationFrame(() => {
        const el = document.getElementById("lead-form");
        if (!el) return;
        const headerH = window.matchMedia("(min-width: 768px)").matches ? 80 : 64;
        const top = el.getBoundingClientRect().top + window.scrollY - headerH - 8;
        window.scrollTo({ top, behavior: "smooth" });
      });
      return () => cancelAnimationFrame(raf);
    }
    if (hash) {
      const raf = requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        const headerH = window.matchMedia("(min-width: 768px)").matches ? 80 : 64;
        const top = el.getBoundingClientRect().top + window.scrollY - headerH - 8;
        window.scrollTo({ top, behavior: "smooth" });
      });
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[70vh]"><Outlet /></main>
      <Footer />
    </>
  );
}

function AdminLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[80vh]"><Outlet /></main>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster theme="light" position="top-right" toastOptions={TOASTER_OPTIONS} />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/find-battery" element={<FindBatteryPage />} />
              <Route path="/find-battery/request" element={<FindBatteryPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/hups-batteries" element={<HupsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
            <Route element={<AdminLayout />}>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/admin" element={<AdminDashboardPage />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
